// frontend/admin-portal/src/services/invoiceService.js
import api from './axiosConfig';

export const invoiceService = {
    list: async (params = {}) => {
        const { data } = await api.get('/invoices', { params });
        return data.data;
    },
    stats: async () => {
        const { data } = await api.get('/invoices/stats');
        return data.data;
    },
    get: async (id) => {
        const { data } = await api.get(`/invoices/${id}`);
        return data.data.invoice;
    },
    create: async (payload) => {
        const { data } = await api.post('/invoices', payload);
        return data.data.invoice;
    },
    update: async (id, payload) => {
        const { data } = await api.put(`/invoices/${id}`, payload);
        return data.data.invoice;
    },
    issue: async (id) => {
        const { data } = await api.patch(`/invoices/${id}/issue`);
        return data.data.invoice;
    },
    void: async (id) => {
        const { data } = await api.patch(`/invoices/${id}/void`);
        return data.data;
    },
    remove: async (id) => {
        const { data } = await api.delete(`/invoices/${id}`);
        return data.data;
    },
};